import { render, staticRenderFns } from "./addTeamTeach.vue?vue&type=template&id=1675bf2f&scoped=true"
import script from "./addTeamTeach.vue?vue&type=script&lang=js"
export * from "./addTeamTeach.vue?vue&type=script&lang=js"
import style0 from "./addTeamTeach.vue?vue&type=style&index=0&id=1675bf2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1675bf2f",
  null
  
)

export default component.exports